import { useHTTP, useHTTPQuery } from "@/lib/http";
import type { PlanModel } from "@/features/subscriptions/api/models/PlanModel";

export const usePlans = () => {
	const http = useHTTP("Required");

	return useHTTPQuery({
		queryKey: ["plans"],
		queryFn: () => http<PlanModel[]>({
			method: "GET",
			url: "/plan"
		})
	});
};
